import { render } from "./CustomCategoryChildComponent.vue?vue&type=template&id=5d174df2&ts=true"
import script from "./CustomCategoryChildComponent.vue?vue&type=script&lang=ts"
export * from "./CustomCategoryChildComponent.vue?vue&type=script&lang=ts"

import "./CustomCategoryChildComponent.vue?vue&type=style&index=0&id=5d174df2&lang=css"

import exportComponent from "C:\\Ventla new admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__